import { webKnots } from '../../../../common/back/lace/webKnots'
import { webToCatchFaceConnect } from '../lace/webToCatchFaceConnect'
import { middleSidePartOfWeb, topSidePartOfWebWithJoint, topSidePartOfWebWithJointStraightLace } from './parts/sideParts'

export const wi7Web = (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  edgeColor: string,
  webColor: string,
  webColor2?: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  // 横上パーツ
  topSidePartOfWebWithJointStraightLace(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -17, 18, 1, 1)
  // 縦パーツ
  ctx.fillStyle = webColor2
  ctx.beginPath()
  ctx.moveTo(610, 160) //左上
  ctx.quadraticCurveTo(607, 176, 563, 226) //左下
  ctx.quadraticCurveTo(585, 250, 599, 283) //右下
  ctx.quadraticCurveTo(633, 254, 648, 225) //右上
  ctx.quadraticCurveTo(635, 186, 610, 160) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.fillStyle = webColor

  // ヘリ革パーツ
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(610, 159) //左上
  ctx.quadraticCurveTo(588, 205, 562, 226) //左下
  ctx.quadraticCurveTo(569, 232, 571, 236) //右下
  ctx.quadraticCurveTo(608, 202, 618, 170) //右上
  ctx.quadraticCurveTo(610, 159, 610, 159) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(644, 211) //左上
  ctx.quadraticCurveTo(625, 248, 594, 272) //左下
  ctx.quadraticCurveTo(600, 278, 598, 283) //右下
  ctx.quadraticCurveTo(629, 257, 649, 225) //右
  ctx.quadraticCurveTo(644, 211, 644, 211) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿内側
  ctx.moveTo(619, 172) //左上
  ctx.quadraticCurveTo(609, 204, 572, 238) //左下

  // 縦向き＿右＿内側
  ctx.moveTo(642, 209) //左上
  ctx.quadraticCurveTo(623, 246, 592, 270) //左下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, 20, 55, 0.9)
  webKnots(ctx, laceColor, 5, -15) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -30, 30) // 捕球面寄りのウェブ結び目
}
